// canvas zoom is a percentage of the canvas resolution (100 % = 1 canvas pixel per 1 screen pixel),
// so the limits are independent of the canvas resolution (HD and 4K zoom identically)
export const canvasMinZoom: number = 10
export const canvasMaxZoom: number = 400
export const canvasZoomStep: number = 10

export const clampCanvasZoom = (zoom: number): number =>
    Math.min(Math.max(zoom, canvasMinZoom), canvasMaxZoom)
